export type DocumentVisualStyle = {
  bg: string;
  text: string;
  label: string;
};

function fileExtension(filename: string, mimeType?: string | null): string {
  const fromName = filename.split('.').pop()?.toLowerCase() ?? '';
  if (fromName) return fromName;
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType?.includes('wordprocessingml')) return 'docx';
  if (mimeType?.includes('spreadsheetml')) return 'xlsx';
  if (mimeType?.includes('presentationml')) return 'pptx';
  if (mimeType?.startsWith('image/')) return mimeType.split('/')[1] ?? 'img';
  return '';
}

export function getBusinessDocumentVisualStyle(
  filename: string,
  mimeType?: string | null,
): DocumentVisualStyle {
  const ext = fileExtension(filename, mimeType);
  if (ext === 'pdf') return { bg: 'bg-red-100', text: 'text-red-700', label: 'PDF' };
  if (['doc', 'docx'].includes(ext)) return { bg: 'bg-blue-100', text: 'text-blue-700', label: ext.toUpperCase() };
  if (['xls', 'xlsx'].includes(ext)) return { bg: 'bg-emerald-100', text: 'text-emerald-700', label: ext.toUpperCase() };
  if (['ppt', 'pptx'].includes(ext)) return { bg: 'bg-orange-100', text: 'text-orange-700', label: ext.toUpperCase() };
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) {
    return { bg: 'bg-amber-100', text: 'text-amber-700', label: ext.toUpperCase() };
  }
  if (['txt', 'csv'].includes(ext)) return { bg: 'bg-app-surface-muted', text: 'text-app-text-muted', label: ext.toUpperCase() };
  return { bg: 'bg-app-surface-muted', text: 'text-app-text-muted', label: ext ? ext.toUpperCase() : '—' };
}

export function isBusinessDocumentPdf(filename: string, mimeType?: string | null): boolean {
  const ext = fileExtension(filename, mimeType);
  return mimeType === 'application/pdf' || ext === 'pdf';
}
